import FilterIcon from './FilterItem';

export default FilterIcon;